var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.395 20.7094C40.965 21.5081 41.25 21.9094 41.25 22.5C41.25 23.0925 40.965 23.4919 40.395 24.2906C37.8338 27.8831 31.2919 35.625 22.5 35.625C13.7062 35.625 7.16625 27.8812 4.605 24.2906C4.035 23.4919 3.75 23.0906 3.75 22.5C3.75 21.9075 4.035 21.5081 4.605 20.7094C7.16625 17.1169 13.7081 9.375 22.5 9.375C31.2938 9.375 37.8338 17.1188 40.395 20.7094Z",
    stroke: "#55749F",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.125 22.5C28.125 21.0082 27.5324 19.5774 26.4775 18.5225C25.4226 17.4676 23.9918 16.875 22.5 16.875C21.0082 16.875 19.5774 17.4676 18.5225 18.5225C17.4676 19.5774 16.875 21.0082 16.875 22.5C16.875 23.9918 17.4676 25.4226 18.5225 26.4775C19.5774 27.5324 21.0082 28.125 22.5 28.125C23.9918 28.125 25.4226 27.5324 26.4775 26.4775C27.5324 25.4226 28.125 23.9918 28.125 22.5Z",
    stroke: "#55749F",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon20);
export default __webpack_public_path__ + "static/media/icon20.3775d369b0116b335323ae782ce4fa63.svg";
export { ForwardRef as ReactComponent };